import { times } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { getCurrency } from "./selectors"
import { getData } from "./selectors/data"
import { getMetrics, getSelectedMetric } from "./selectors/metrics"
import { getItems, getChartItems } from "./selectors/items"
import { getDetailsItems, getDetailsData, getFactorsCategories, getTableDownloadData } from "./selectors/details"
import { getStatus } from "./selectors/status"
import { getPositionSet } from "helpers/comparison"
import { Creators } from "./model"
import { VIEW_TYPES } from "helpers/base"
import { getFileName } from "modules/comparison/selectors/"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state, props) => ({
    currency: getCurrency(state, props),
  }),
  required: ["account", "modelId", "positionSets", "startDate", "endDate"],
  data: [...times(5, (n) => {
    return {
      resource: `compareRiskPositionSet${n}`,
      as: null,
      passthrough: n > 0,
      url: ({ modelId, positionSets, startDate, endDate, base, viewType, currency }) => {
        if (!positionSets[n] || positionSets[n].uploading) {
          return null
        }

        const positionSet = getPositionSet(positionSets, n, startDate, { currency })

        // If a segment is applied on the positionSet, use that segment on the base
        const baseCopy = { ...base }
        if (positionSet.segment) {
          baseCopy.segment = positionSet.segment
        }

        return {
          id: `${modelId}${JSON.stringify(positionSet)}${startDate}${endDate}${viewType === VIEW_TYPES.ACTIVE ? JSON.stringify(baseCopy) : ""}${currency}`,
          query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
                model (id: $modelId) {
                  simulation (positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
                    risk {
                      date
                      total
                      attribution {
                        summary {
                          factors
                          specific
                        }
                        factors {
                          id
                          category
                          name
                          value
                        }
                      }
                    },
                  }
                }
              }`,
          variables: {
            modelId,
            positionSet,
            from: startDate,
            to: endDate,
            base: viewType === VIEW_TYPES.ACTIVE ? [baseCopy] : undefined,
          },
        }
      },
    }
  }),
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    data: getData(state, props),
    metrics: getMetrics(state),
    items: getItems(state, props),
    chartItems: getChartItems(state, props),
    detailsItems: getDetailsItems(state, props),
    detailsData: getDetailsData(state, props),
    status: getStatus(state),
    selectedMetric: getSelectedMetric(state, props),
    factorCategories: getFactorsCategories(state, props),
    fileName: getFileName(state, props),
    tableDownloadData: getTableDownloadData(state, props),
  }),
  actions: {
    ...Creators,
  },
})
